import React from 'react'
import PropTypes from 'prop-types'
import { SectionTitleStyle } from './texts.styles'

const proptypes = {
	title: PropTypes.string.isRequired,
}

export const SectionTitle = ({ title }) => {
	return <SectionTitleStyle>{title}</SectionTitleStyle>
}

SectionTitle.propTypes = proptypes
